import React from "react";
import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";
import { GadgetLogoMark } from "@gadgetinc/widgets/src/icons/GadgetLogo";
import { WebsiteIcon } from "@gadgetinc/widgets/src/icons/WebsiteIcon";
import { ShopifyWebhookIcon } from "@gadgetinc/widgets/src/icons/ShopifyWebhookIcon";

const TutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
            fontWeight: 300,
          }}
        >
          Gadget tutorials are designed to demonstrate how quickly and effortlessly you can build expressive, dynamic apps.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            icon={<GadgetLogoMark width={32} />}
            title="Quickstart"
            color={colors.white}
            body="New to Gadget? Build your first fullstack app in 10 minutes!"
            href="/guides/getting-started/quickstart"
            copy="Get started →"
          />
          <SplashCard
            title="Shopify apps"
            icon={<ShopifyWebhookIcon $size={32} />}
            color={colors.white}
            body="Learn how to build fullstack Shopify apps, use Shopify extensions, and build integrations."
            href="/guides/tutorials/shopify"
            copy="See the tutorials →"
          />
          <SplashCard
            title="Web apps"
            icon={<WebsiteIcon $size={32} />}
            color={colors.white}
            body="Learn how to build fullstack web apps that use Gadget's built-in authentication system and OpenAI plugin."
            href="/guides/tutorials/web-ai"
            copy="See the tutorials →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default TutorialsLandingPage;
